export { default as personReducer } from './reducer';
